"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isObservable(obj) {
    return obj && typeof obj.subscribe === 'function';
}
function isPromise(obj) {
    return obj && typeof obj.then === 'function';
}
class ObservableStrategy {
    createSubscription(async, updateLatestValue) {
        this._subscription = async.subscribe({ next: updateLatestValue, error: (e) => { throw e; } });
        return this._subscription;
    }
    dispose() {
        this._subscription.unsubscribe();
        this.latestValue = null;
    }
    onDestroy() { this._subscription.unsubscribe(); }
}
class PromiseStrategy {
    createSubscription(async, updateLatestValue) {
        this._subscription = async.then(updateLatestValue, e => { throw e; });
        return this._subscription;
    }
    dispose() {
        this.latestValue = null;
    }
    onDestroy() { }
}
class AsyncFilterClass {
    constructor() {
        this.transform = this.transform.bind(this);
        this._subscriptionMap = new WeakMap();
    }
    _selectStrategy(obj) {
        if (isPromise(obj)) {
            return new PromiseStrategy();
        }
        if (isObservable(obj)) {
            return new ObservableStrategy();
        }
        throw new TypeError(`AsyncFilter: expect an async type but received: ${typeof obj}`);
    }
    _subscribe(obj, scope) {
        const strategy = this._selectStrategy(obj);
        strategy.createSubscription(obj, (value) => {
            strategy.latestValue = value;
            this._updateLatestValue(obj, value, scope);
        });
        this._subscriptionMap.set(obj, strategy);
        scope.$on('$destroy', () => {
            strategy.dispose();
            this._subscriptionMap.delete(obj);
        });
    }
    _updateLatestValue(async, value, scope) {
        if (this._subscriptionMap.has(async)) {
            scope.$applyAsync();
        }
    }
    transform(obj, scope) {
        if (!scope) {
            throw new SyntaxError('AsyncFilter: Scope object is expected. Please make sure you have correct syntax `{{ your_binding_value | async:this }}`');
        }
        if (!this._subscriptionMap.has(obj)) {
            if (obj) {
                this._subscribe(obj, scope);
            }
        }
        return this._subscriptionMap.get(obj).latestValue;
    }
}
angular.module('callX').filter('async', () => new AsyncFilterClass().transform);
